import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { DateTime } from 'luxon';
import { getNotificationTypeIcon, NotificationTypeEnum } from '../../constants/notification.constant';
import { INotificationItem } from '../../models/notification.model';

@Component({
    selector: 'app-notification',
    standalone: false,
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.scss',
})
export class NotificationComponent {
    @Output() notificationRead = new EventEmitter<number>();
    @Output() notificationClick = new EventEmitter<INotificationItem>();
    protected notificationSignal = signal<INotificationItem | null>(null);
    protected NotificationTypeEnum = NotificationTypeEnum;
    protected getNotificationTypeIcon = getNotificationTypeIcon;
    private initialNotification!: INotificationItem;

    @Input() set notification(value: INotificationItem) {
        this.initialNotification = value;
        this.notificationSignal.set(value);
    }

    protected timeAgo(time: string): string | null {
        return DateTime.fromISO(time).toRelative();
    }

    protected handleRead(): void {
        this.notificationRead.emit(this.initialNotification.id);
    }

    protected handleClick(): void {
        this.notificationClick.emit(this.initialNotification);
    }
}
